import { resolveEffectiveServiceCountBounds } from './resolveServiceCountMode';
import type { Product } from '@features/products/types/products.types';

// Mirrors quote-service's filled service-count minimum.
// Falls back to 1 when the product is missing or its bounds are unreadable.
export function minimumConfiguredServices(product: Product | null | undefined): number {
    if (!product) return 1;
    return resolveEffectiveServiceCountBounds(product.config_settings)?.min ?? 1;
}
